module.exports = __webpack_public_path__ + "img/eos.90a08310.png";